export default __webpack_public_path__ + "static/media/pieces.722fa615.svg";